import { Classificacao } from './classificacao';
import { Funcionario } from './funcionario';

export class GestaoDesconto {

  descontoUsuario: number;
  descontoTime: number;
  time: Funcionario[];
  classificacao: Classificacao[];
}
